<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters justify="center" align="center">
      <v-col 
        lg="6"
        md="6"
        sm="12"
        xs="12"
        class="ml-auto mr-auto">
        <v-row>
          <v-select class="pr-2"
              v-model="select"
              :items="selection_options"
              item-text="title"
              item-value="value"
              :label="placeholder"
              :error-messages="!checkValid ? error_message: ''"
              return-object
              solo
          ></v-select>
          <v-btn class="mt-1" dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">Submit</v-btn>
      </v-row>
      </v-col>
    </v-row> -->
    <div class="selectBox">
      <div class="inquireForm">
          <label>{{placeholder}} <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span> 
          <strong class="error" v-if="!checkValid">{{error_message}}</strong></label>
          <select class="formItem" v-model="select" @change="submit">
            <option selected value="-1">{{placeholder}}</option>
            <option v-for="(item, index) in selection_options" v-bind:key="index" :value="index">{{item.title}}</option>
          </select>
      </div>

     <!--  <div class="submitBtn">
        <button @click="submit">SUBMIT</button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownInput",
  props: ['placeholder', 'error_message', 'bot_setting', 'is_required', 'selection_options', 'label_name'],

  created(){
    this.checkValid = true
    
  },

  data: () =>({
    select: -1,
    options:[],
    checkValid: true,
    //error_message: 'Please select an option',
  }),


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      //console.log(this.select)
      if (this.select >=0){
        this.checkValid = true
        var emitValue = {user_chat_message: this.selection_options[this.select].title, user_chat_value:this.selection_options[this.select].value}
        this.$emit('dropdown_input_submitted', emitValue)
        
      }else{
        //this.checkValid = false
      } 
    },
  },
  watch:{
    // select: function(){
    //   this.checkValid = true
    // }
  }
}
</script>